<div class="panel-group">
    <div class="panel panel-default">
        <div [class.panel-heading]="poweredby.Status==0 || live" [class.panel-Staged1]="poweredby.Status==1 || poweredby.Status==2" [class.panel-warning1]="poweredby.Status==4">
            <h5 style="display: inline-block">
                <span class="badge">
                    {{ equipment.Data.length }}
                </span>
                <span [style.color]="(poweredby.Status==0 || live) ?'black':'white'">{{ poweredby.Name }} </span>
            </h5>
            <div class="pull-right btn-toolbar" role="toolbar">
                <div class="btn-group btn-group-sm">
                    <button type="button" class="btn btn-info btn-sm" title="Expand" (click)="showEquipment()">
                        <span data-toggle="tooltip" class="fa fa-lg" [class.fa-chevron-down]="!equipmentVisible" [class.fa-chevron-up]="equipmentVisible"></span>
                    </button>
                </div>  
                <ng-container *ngIf="!live">
                    <div class="btn-group btn-group-sm" *ngIf="!listOnly">
                        <button type="button" class="btn btn-info" title="Add Equipment" (click)="addEquipment()">
                            <span data-toggle="tooltip" class="fa fa-plus-square fa-lg"></span>
                        </button>
                    </div>
                </ng-container>
            
            </div>
        </div>
        <div class="panel-collapse collapse" [class.in]="equipmentVisible" *ngIf="listOnly">
            <div class="panel-body" *ngIf="equipmentVisible">
                <ng-container *ngIf="live">
                    <equipment-entity [forDocuments]="listOnly" [attr.data-equipment-id]="eq.Id" [equipment]="eq" [poweredby]="poweredby" [model]="model" [full]="true" *ngFor="let eq of equipment.Data"></equipment-entity>
                </ng-container>
                <ng-container *ngIf="!live">
                    <equipment-entity [live]="live" [forDocuments]="listOnly" [attr.data-equipment-id]="eq.Equipment_ID" [equipment]="eq" [poweredby]="poweredby" [model]="model" [full]="true" *ngFor="let eq of equipment.Data"></equipment-entity>
                </ng-container>
            </div>
        </div>
        <div class="panel-collapse collapse" [class.in]="equipmentVisible" *ngIf="!listOnly">
            <div class="panel-body" *ngIf="equipmentVisible" cdkDropList cdkDropListData="equipment.Data">
                <ng-container *ngIf="live">
                    <equipment-entity [live]="live" [forDocuments]="listOnly" [attr.data-equipment-id]="eq.Id" [equipment]="eq" [poweredby]="poweredby" [model]="model" [full]="true" *ngFor="let eq of equipment.Data"></equipment-entity>
                </ng-container>
                <ng-container *ngIf="!live">
                    <equipment-entity [live]="live" [forDocuments]="listOnly" [attr.data-equipment-id]="eq.Equipment_ID" [equipment]="eq" [poweredby]="poweredby" [model]="model" [full]="true" *ngFor="let eq of equipment.Data"></equipment-entity>
                </ng-container>
            </div>
        </div>
    </div>
</div>
